import { Link } from "react-router-dom";
import { Languages } from "lucide-react";
import { FreeTrialText } from "./PricingCopy";

export function MarketingHeader() {
  return (
    <header className="sticky top-0 z-40 border-b border-zinc-800 bg-zinc-950/85 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <Languages className="w-5 h-5 text-blue-500" />
          <span className="font-heading text-lg font-black tracking-tighter text-white">LinguaSub</span>
        </Link>
        <nav className="hidden md:flex items-center gap-5 text-xs font-mono uppercase tracking-widest">
          <Link to="/features" className="text-zinc-400 hover:text-white">Features</Link>
          <Link to="/how-it-works" className="text-zinc-400 hover:text-white">How it works</Link>
          <Link to="/pricing" className="text-zinc-400 hover:text-white">Pricing</Link>
          <Link to="/blog" className="text-zinc-400 hover:text-white">Blog</Link>
          <Link to="/faqs" className="text-zinc-400 hover:text-white">FAQs</Link>
          <Link to="/" className="bg-white text-zinc-950 px-3 py-1.5 hover:bg-zinc-200">Sign in</Link>
        </nav>
        <Link to="/" className="md:hidden text-xs font-mono uppercase tracking-widest text-zinc-400">Menu →</Link>
      </div>
    </header>
  );
}

export function CTASection({ title = "Ready to try LinguaSub?", subtitle = <><FreeTrialText />. No card needed.</> }) {
  return (
    <section className="border-t border-zinc-800 bg-zinc-900/40">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20 text-center">
        <h3 className="font-heading text-3xl md:text-4xl font-black tracking-tighter mb-3 text-white">{title}</h3>
        <p className="text-sm text-zinc-400 mb-8">{subtitle}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="h-11 px-6 bg-white text-zinc-950 hover:bg-zinc-200 font-semibold text-sm inline-flex items-center rounded-none">Start free →</Link>
          <Link to="/pricing" className="h-11 px-6 border border-zinc-700 bg-transparent hover:bg-zinc-900 text-white text-sm inline-flex items-center rounded-none">See pricing</Link>
        </div>
      </div>
    </section>
  );
}

export function FAQBlock({ items }) {
  return (
    <section className="border-t border-zinc-800">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-3">Frequently asked</div>
        <h2 className="font-heading text-3xl md:text-5xl font-black tracking-tighter mb-10 text-white">Questions we get a lot.</h2>
        <div className="divide-y divide-zinc-800 border-t border-zinc-800">
          {items.map((it) => (
            <details key={it.q} className="group py-5">
              <summary className="cursor-pointer list-none flex items-start justify-between gap-4 text-white">
                <span className="text-base md:text-lg font-semibold pr-4">{it.q}</span>
                <span className="text-zinc-500 text-xl group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="text-sm text-zinc-400 leading-relaxed mt-3">{it.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
